class ShopListServ {

    constructor(storeServ, $sce) {
        this.storeServ = storeServ;
        this.$sce = $sce;
    }

    mapShopPropertiesToDisplay(shops) {
        return shops.map((shop) => {
            return {
                name: shop.name,
                type: shop.type,
                description: shop.description,
                todaysProgram: shop.todaysProgram,
                distance: shop.distance,
                pos: shop.pos
            };
        });
    }

    filterShopsInHighlightedBounds(shops) {
        let boundsToHighlight = this.storeServ.getState().boundsToHighlight;
        let highlightedBounds;

        if (boundsToHighlight) {

            highlightedBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(boundsToHighlight.southWestLat, boundsToHighlight.southWestLng),
                new google.maps.LatLng(boundsToHighlight.northEastLat, boundsToHighlight.northEastLng)
            );

            return shops.filter((shop) => {
                let shopLocation = new google.maps.LatLng(shop.lat, shop.lng);
                return highlightedBounds.contains(shopLocation);
            });

        } else {
            return shops;
        }
    }

    sanitizeShopProperties(shops) {
        return shops.map((shop) => {
            if (typeof shop.description === 'string') {
                shop.description = this.$sce.trustAsHtml(shop.description);
            }
            return shop;
        });
    }
}

ShopListServ.$inject = ['storeServ', '$sce'];

export default ShopListServ;
